import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const CartFillIconSvg = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.96875 25.375C10.9698 25.375 11.7812 24.5635 11.7812 23.5625C11.7812 22.5615 10.9698 21.75 9.96875 21.75C8.96773 21.75 8.15625 22.5615 8.15625 23.5625C8.15625 24.5635 8.96773 25.375 9.96875 25.375Z"
      fill="currentColor"
    />
    <path
      d="M22.6562 25.375C23.6573 25.375 24.4688 24.5635 24.4688 23.5625C24.4688 22.5615 23.6573 21.75 22.6562 21.75C21.6552 21.75 20.8438 22.5615 20.8438 23.5625C20.8438 24.5635 21.6552 25.375 22.6562 25.375Z"
      fill="currentColor"
    />
    <path
      d="M25.8734 6.84105C25.7461 6.68532 25.5857 6.55989 25.4039 6.47387C25.222 6.38785 25.0233 6.3434 24.8222 6.34375H7.58361L7.23641 4.37379C7.19938 4.16395 7.08961 3.97387 6.92636 3.83693C6.76311 3.69999 6.55683 3.62496 6.34375 3.625H2.71875C2.4784 3.625 2.24789 3.72048 2.07793 3.89043C1.90798 4.06039 1.8125 4.2909 1.8125 4.53125C1.8125 4.7716 1.90798 5.00211 2.07793 5.17207C2.24789 5.34202 2.4784 5.4375 2.71875 5.4375H5.58363L8.16984 20.095C8.20687 20.3048 8.31664 20.4949 8.47989 20.6318C8.64314 20.7688 8.84942 20.8438 9.0625 20.8438H23.5625C23.8029 20.8438 24.0334 20.7483 24.2033 20.5783C24.3733 20.4084 24.4688 20.1779 24.4688 19.9375C24.4688 19.6971 24.3733 19.4666 24.2033 19.2967C24.0334 19.1267 23.8029 19.0312 23.5625 19.0312H9.82262L9.50316 17.2188H23.1909C23.5052 17.2184 23.8097 17.1094 24.0529 16.9103C24.2961 16.7112 24.463 16.4342 24.5254 16.1262L26.1566 7.9699C26.1959 7.77251 26.1909 7.56885 26.142 7.37364C26.093 7.17842 26.0013 6.99652 25.8734 6.84105Z"
      fill="currentColor"
    />
  </svg>
);

export const CartFillIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={() => <CartFillIconSvg />} {...props} />
);

export default CartFillIcon;

CartFillIcon.displayName = "CartFillIcon";
